import React from 'react'

const ScrollToTopButton = () => {
  return <div className='back-to-top' id='ontop'>
    <i className="icon link grey big ta-arrow-2-up"></i>
  </div>
}

export default ScrollToTopButton